import React from 'react';
import { Modal, Table } from 'antd';


const columns = [
    {
      title: 'Name',
      dataIndex: 'referral_name',
      key: 'referral_name',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Phone Number',
      dataIndex: 'phone',
      key: 'phone',
    },
  ];

const ShowReferrals = (props)=> {

    return (
      <Modal
          title="Referrals Given"
          visible={props.visible}
          footer={null}
          centered
          width={650}
          onCancel={()=>props.handleCancel()}
          destroyOnClose={true}
          maskClosable={false}
        
        > 
       <div style={{overflow:'auto'}}>
       {props.data && <Table dataSource={props.data} pagination={false} columns={columns} />} 
        </div>
        
        </Modal>
    );
    }

export default ShowReferrals 


// WEBPACK FOOTER //
// ./src/scenes/LandingPage/showReferrals.js